var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "auto" } },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(
            " " +
              _vm._s(_vm.$t(`customer.shipping_management.auto_assign.title`)) +
              " "
          ),
        ]),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("i", [
            _vm._v(
              _vm._s(
                _vm.$t(`customer.shipping_management.auto_assign.description`)
              )
            ),
          ]),
          _vm._l(_vm.autoAssignObject, function (obj) {
            return _c("div", { key: obj.id }, [
              _c(
                "div",
                {
                  staticClass: "custom-container row has-background-white-ter",
                  class: obj.checked ? "checked" : "not-checked",
                  on: {
                    click: function ($event) {
                      return _vm.checkRow(obj)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "space-around" }, [
                    _c("div", { staticClass: "d-row" }, [
                      _c("div", { staticClass: "d-col" }, [
                        _c("span", { staticClass: "row-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `customer.shipping_management.auto_assign.reference`
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("span", [_vm._v(" " + _vm._s(obj.reference) + " ")]),
                      ]),
                      _c("div", { staticClass: "d-col" }, [
                        _c("span", { staticClass: "row-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `customer.shipping_management.auto_assign.reference_complement`
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(" " + _vm._s(obj.referenceComplement) + " "),
                        ]),
                      ]),
                      _c("div", { staticClass: "d-col" }, [
                        _c("span", { staticClass: "row-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  `customer.shipping_management.auto_assign.date`
                                )
                              ) +
                              " "
                          ),
                        ]),
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(obj.formatedDate) +
                              " - " +
                              _vm._s(obj.formatedhour) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "d-col-center" }, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t(
                              `customer.shipping_management.auto_assign.enduser`
                            )
                          ) +
                          " "
                      ),
                    ]),
                    _c("span", { staticClass: "has-text-success" }, [
                      _vm._v(" " + _vm._s(obj.enduser.name || "ERROR") + " "),
                    ]),
                  ]),
                ]
              ),
            ])
          }),
        ],
        2
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "button",
          {
            staticClass: "button is-fullwidth",
            on: {
              click: function ($event) {
                return _vm.$parent.close()
              },
            },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(`customer.shipping_management.auto_assign.cancel`)
                ) +
                " "
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "button is-info is-fullwidth",
            class: { "is-loading": _vm.isSubmitting },
            attrs: { type: "submit" },
            on: { click: _vm.submitData },
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t(`customer.shipping_management.auto_assign.submit`)
                ) +
                " "
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }